import ProductListPage from "../components/blocks/ProductListPage/ProductListPage";
import { activeCardGames, singlesListingProps } from "../utils/singlesListing";
import MetaElement from "../components/elements/MetaElement";

const Singles = (props) => (
  <>
    <MetaElement pageId="singles" />
    <ProductListPage {...props} view="singles" />
  </>
);

Singles.getInitialProps = async function (ctx) {
  let activeGames = [];
  try {
    const response = await activeCardGames(ctx);
    activeGames = (response && response.data) || [];
  } catch (e) {
    activeGames = [];
  }

  // Legacy `?game=<id>` deep links from before the slug migration. The id
  // in those URLs is the Cardmarket id (that's what the legacy picker
  // emitted) — match against `cardMarketId`, not the local PK.
  if (ctx.query && ctx.query.game && ctx.res) {
    const id = parseInt(ctx.query.game, 10);
    const match = activeGames.find((g) => g.cardMarketId === id);
    if (match) {
      ctx.res.writeHead(301, { Location: `/singles/${match.slug}` });
      ctx.res.end();
      return { activeGames };
    }
  }

  return { ...(await singlesListingProps(ctx)), activeGames };
};

export default Singles;
